import { render, staticRenderFns } from "./GlobalColorsList.vue?vue&type=template&id=200cdeb2&"
import script from "./GlobalColorsList.vue?vue&type=script&lang=ts&"
export * from "./GlobalColorsList.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalColorsList.vue?vue&type=style&index=0&id=200cdeb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports